import { render, staticRenderFns } from "./RequestStatisticsIndex.vue?vue&type=template&id=6e2f73a2&"
import script from "./RequestStatisticsIndex.vue?vue&type=script&lang=js&"
export * from "./RequestStatisticsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports